document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".featured-collection-tab");
  const tabContents = document.querySelectorAll(".tab-content");
  const viewMoreButtons = document.querySelectorAll(".view-more-btn");
  // Initialize all splides
  function initSplide(splideEl) {
    if (!splideEl || splideEl.classList.contains("is-initialized")) return;
    if (window.Splide) {
      const autoplay = splideEl.dataset.autoplay === "true";
      const interval = parseInt(splideEl.dataset.autoplaySpeed) || 3000;
      const splide = new Splide(splideEl, {
        type: "carousel",
        drag:true,
        gap: "1rem",
        perPage: 4,
        perMove: 1,
        pagination: true,
        arrows: false,
        autoplay: autoplay,
        interval: interval,
        pauseOnHover: true,
        breakpoints: {
          1025: { perPage: 2.2, gap: "0.8rem" },
          750: { perPage: 2.2, gap: "0.4rem" },
        },
      });
      splide.mount();
      splideEl.classList.add("is-initialized");
    }
  }
  // Init first visible Splide
  tabContents.forEach((tabContent) => {
    if (tabContent.classList.contains("active-tab")) {
      const splideEl = tabContent.querySelector(".splide");
      initSplide(splideEl);
    }
  });
  // Handle tab switching
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const tabId = this.dataset.tabId;
      // Reset all tabs
      tabButtons.forEach((btn) => {
        btn.classList.remove("active-collection-tab");
        btn.setAttribute("aria-selected", "false");
      });
      tabContents.forEach((content) => content.classList.add("hidden"));
      viewMoreButtons.forEach((btn) => btn.classList.add("hidden"));
      // Activate selected tab + button + view more
      this.classList.add("active-collection-tab");
      this.setAttribute("aria-selected", "true");
      const activeContent = document.querySelector(`#tab-${tabId}`);
      if (activeContent) {
        activeContent.classList.remove("hidden");
        activeContent.classList.add("active-tab");
        const splideEl = activeContent.querySelector(".splide");
        initSplide(splideEl);
      }
      const activeViewMore = document.querySelectorAll(
        `.view-more-btn[data-tab-id="${tabId}"]`
      );
      activeViewMore.forEach((btn) => {
        btn.classList.remove("hidden");
        btn.classList.add("active-button");
      });
    });
  });
});